import axios from 'axios';
import router from "@/plugins/router";
import Authentication from '@/services/Authentication'
import {vueInstance} from '@/main'

export default class Http401Middleware {

    static async config(){
        axios.interceptors.response.use( async (response) => {
            return response;
        }, async (error) => {
            if(error.response.status === 401) {
                console.log('Expired login');
                // Authentication.Logout();
                router.push({path: Authentication.expiredRoute })
            }else if(error.response.status != 200){
                console.log(error.response.data?.message)

                //if(error.response.data?.title && error.response.data?.errors){
                  // var errors = error.response.data.errors.join('<br/>')
                   //console.log(errors)
                  // vueInstance.$root.vtoast.error()
                // }
                // else {
                    console.log('errors')
                    vueInstance.$root.vtoast.error(error.response.data?.message ?? 'Erro interno')
                // }
             
               return Promise.reject(error);
            }
        })
    }
}
